import './style/Banner.css';
import React, { useEffect, useState } from 'react';
import { getImgUrl } from '../../util/ImageSource';
import { formatToCurrency, displayPriceForProduct } from '../../util/Calculate';

import { } from '../../redux/temporarySlice';
import { useSelector } from 'react-redux';
import { Navigate, Text } from '@harperai/materialize-design-system';

const Banner = () => {
    const featuredProducts = useSelector((state) => state.temporary?.featuredProducts);
    const [featured, setFeatured] = useState([]);

    useEffect(() => {
        if (featuredProducts?.length > 0) {
            const mastechItem = featuredProducts.find(product => product.marketMpn === "MS6522B Infrared Thermometer");
            const kpsOne = featuredProducts.find(product => product.marketMpn === "MT490 Digital Environmental Multimeter");
            const kpsTwo = featuredProducts.find(product => product.marketMpn === "MT700 Digital Multimeter");
            setFeatured([mastechItem, kpsOne, kpsTwo]);
        }
    }, [featuredProducts]);

    return (
        <div className="shop-max-width flex vertical relative gap-m no-pad-bo width-100">
            <div className="banner flex vertical relative pad-m">
                <div className="flex yellow-bg round-m no-round-bot no-pad-bot vertical pad-l">
                    <div className="flex horizontal space-between align-center align-items-start flex-1 gap-xl">
                        <div className="flex vertical">
                            <Text header={1} size="h5" bold={true}>KPS & MASTECH SALE!</Text>
                        </div>
                        <Navigate href="/categories/test-equipment" variant="white">Shop All Test Equipment</Navigate>
                    </div>
                    <div className="">
                        <Text header={2} size="title">Save up to 60% on all test equipment lots.</Text>
                    </div>
                </div>
                {/* <img src={KpsLogo} alt="KPS Logo" className="banner-logo" /> */}
                <div className="flex yellow-bg round-m no-round-top pad-l horizontal flex-1 gap-xl">
                    {featured?.length > 0 && featured.map((product, index) => (
                        <div key={index + product.marketMpn} className={`banner-item round-s flex horizontal flex-1 relative ${index !== 0 ? "mobile-hide" : ""}`}>
                            <img src={getImgUrl(product)} alt={product.marketManufacturer} className={`banner-image saturate no-pointer`} />
                            <div className="banner-item-content flex vertical justify-center flex-1">
                                <div className="flex vertical gap-xxs">
                                    <Text header={3} size="caption" bold={true}>{product.marketManufacturer}</Text>
                                    <Text header={4} size="title" bold={true} classes="banner-text fix-stroke">{product.marketMpn}</Text>
                                </div>
                                <div className="flex vertical">
                                    <div className="flex horizontal align-center gap-s">
                                        <Text header={5} size="h1">{formatToCurrency(displayPriceForProduct(product))}</Text>
                                        <Navigate
                                            icon="chevron-right"
                                            href={`/products/${encodeURIComponent(product.marketManufacturer?.toLowerCase())}/${encodeURIComponent(product.marketMpn?.toLowerCase())}`}
                                            variant="white"
                                            size="small" />
                                    </div>
                                    <Text header={6} size="caption" bold={true}>{`Per lot of ${product?.stock[0]?.lot_size}`}</Text>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Banner;